import React, { useState, useEffect } from "react";
import AddButtonSection from '../../components/common/AddButtonSection';
import { useForm } from "react-hook-form";
import {
  renderInputHeader,
  pattern,
  commonData,
  addLookUpOption,
} from "../../utils/utils";
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { DevTool } from "@hookform/devtools";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";
export default function ClinicalInformation({ patientVisitId }) {
  const defaultValues = {
    pulse: "",
    height: "",
    weight: "",
    blood_pressure: "",
    procedures: "",
    immunizations: "",
    medications: "",
    additional_notes: "",
    allergies: [],
    medical_history: [],
    ophthalmic_history: [],
    family_history: [],
  };
  const {
    control,
    formState: { errors, dirtyFields },
    setValue,
    watch,
    register,
    handleSubmit,
    reset,
  } =
    useForm({
      defaultValues: {
        height: "",
        weight: "",
        blood_pressure: "",
        pulse: "",
        procedures: "",
        immunizations: "",
        medications: "",
        additional_notes: "",
        allergies: [],
        medical_history: [],
        ophthalmic_history: [],
        family_history: [],
      }
    });

  let headers = {
    "Content-Type": "application/json",
  };
  const bloodPressure = watch("blood_pressure");
  const weight = watch("weight");
  const height = watch("height");
  const [isBackspace, setIsBackspace] = useState(false);
  const [isAlphabatic, setIsAlphabatic] = useState(false);
  const [medicalHistory, setMedicalHistory] = useState([]);
  const [ophthalmicHistory, setOphthalmicHistory] = useState([]);
  const [clinicalData, setClinicalData] = useState(null);
  const [allergies, setAllergies] = useState([]);
  const [familyHistory, setfamilyHistory] = useState([]);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const lookupTypes = [
    { type: "Medical History", setter: setMedicalHistory },
    { type: "Allergies", setter: setAllergies },
    { type: "Ophthalmic History", setter: setOphthalmicHistory },
    { type: "Family History", setter: setfamilyHistory },
  ];
  const totalForm = [
    {
      type: "input-group",
      parentType: "plain",
      header: "Vitals",
      customClass: "w-full md:pb-3",
      formRender: [
        {
          type: "text",
          name: "height",
          label: "Height",
          fieldLabel: "height",
          placeholder: "cm",
          inputParentClass: "w-6 md:w-full pr-3 pb-4 ",
          maxLength: 5
        },
        {
          type: "text",
          name: "weight",
          label: "Weight",
          fieldLabel: "weight",
          placeholder: "kg",
          inputParentClass: "w-6 md:w-full pr-3 pb-4",
          maxLength: 5
        },
        {
          type: "text",
          name: "blood_pressure",
          label: "Blood Pressure",
          fieldLabel: "blood_pressure",
          placeholder: "XXX/XXX",
          inputParentClass: "w-6 md:w-full pr-3 pb-4",
          maxLength: 7,
        },
        {
          type: "text",
          name: "pulse",
          label: "Pulse",
          fieldLabel: "pulse",
          inputParentClass: "w-6 md:w-full pr-3 pb-4",
          maxLength: 3,
          rules: {
            pattern: {
              value: pattern("number"),
              message: "*Accept only number",
            },
          },
        },
      ],
    },
    {
      parentType: "wrap",
      wrap: [
        {
          type: "input-group",
          parentType: "wrap-with-flex",
          header: "Ophthalmic History",
          customClass: "md:py-3",
          formRender: [
            {
              type: "multiselect",
              name: "ophthalmic_history",
              label: "Select",
              fieldLabel: "ophthalmic_history",
              placeholder: "Type here",
              value: commonData(ophthalmicHistory, watch("ophthalmic_history")),
              inputParentClass: "w-full pr-3 pb-4",
              options: ophthalmicHistory,
              nestedInput: { ...register("_ophthalmic_history") },
              nestedOnClick: (a, b) => {
                if (dirtyFields?._ophthalmic_history) {
                  addLookUpOption(
                    {
                      lookup_type_name: "Ophthalmic History",
                      name: watch("_ophthalmic_history"),
                    },
                    () => {
                      fetchOptions(
                        "Ophthalmic History",
                        setOphthalmicHistory,
                        showToast
                      );
                    },
                    showToast
                  );
                  setValue("_ophthalmic_history", "");
                }
              },
            },
          ],
        },
        {
          type: "input-group",
          parentType: "wrap-with-flex",
          header: "Allergies",
          customClass: "md:py-3",
          formRender: [
            {
              type: "multiselect",
              name: "allergies",
              label: "Select",
              fieldLabel: "allergies",
              placeholder: "Type here",
              options: allergies,
              value: commonData(allergies, watch("allergies")),
              inputParentClass: "w-full pr-3 pb-4",
              nestedInput: { ...register("_allergies") },
              nestedOnClick: () => {
                if (dirtyFields?._allergies) {
                  addLookUpOption(
                    {
                      lookup_type_name: "Allergies",
                      name: watch("_allergies"),
                    },
                    () => {
                      fetchOptions("Allergies", setAllergies, showToast);
                    },
                    showToast
                  );
                  setValue("_allergies", "");
                }
              },
            },
          ],
        },
      ],
    },
    {
      parentType: "wrap",
      wrap: [
        {
          type: "input-group",
          parentType: "wrap-with-flex",
          header: "Medical History",
          customClass: "md:py-3",
          formRender: [
            {
              type: "multiselect",
              name: "medical_history",
              label: "Select",
              fieldLabel: "medical_history",
              placeholder: "Type here",
              options: medicalHistory,
              value: commonData(medicalHistory, watch("medical_history")),
              inputParentClass: "w-full pr-3 pb-4",
              nestedInput: { ...register("_medical_history") },
              nestedOnClick: () => {
                if (dirtyFields?._medical_history) {
                  addLookUpOption(
                    {
                      lookup_type_name: "Medical History",
                      name: watch("_medical_history"),
                    },
                    () => {
                      fetchOptions(
                        "Medical History",
                        setMedicalHistory,
                        showToast
                      );
                    },
                    showToast
                  );
                  setValue("_medical_history", "");
                }
              },
            },
          ],
        },
        {
          type: "input-group",
          parentType: "wrap-with-flex",
          header: "Family History",
          customClass: "md:py-3",
          formRender: [
            {
              type: "multiselect",
              name: "family_history",
              label: "Select",
              fieldLabel: "family_history",
              placeholder: "Type here",
              options: familyHistory,
              value: commonData(familyHistory, watch("family_history")),
              inputParentClass: "w-full pr-3 pb-4",
              nestedInput: { ...register("_family_history") },
              nestedOnClick: () => {
                if (dirtyFields?._family_history) {
                  addLookUpOption(
                    {
                      lookup_type_name: "Family History",
                      name: watch("_family_history"),
                    },
                    () => {
                      fetchOptions(
                        "Family History",
                        setfamilyHistory,
                        showToast
                      );
                    },
                    showToast
                  );
                  setValue("_family_history", "");
                }
              },
            },
          ],
        },
      ],
    },
    {
      parentType: "wrap-plain",
      customParentClass: "flex flex-wrap max-w-full",

      wrap: [
        {
          type: "input-group",
          parentType: "wrap-with-flex",
          header: "Procedures",
          customClass: "md:py-3",
          customChildClass: "w-full md:flex-1",
          formRender: [
            {
              type: "text",
              name: "procedures",
              label: "Comments",
              fieldLabel: "procedures",
              // placeholder: "Type to search",
              inputParentClass: "w-full pr-3 pb-4",
            },
          ],
        },
        {
          type: "input-group",
          parentType: "wrap-with-flex",
          header: "Immunizations",
          customClass: "md:py-3",
          customChildClass: "w-full md:flex-1",
          formRender: [
            {
              type: "text",
              name: "immunizations",
              label: "Comments",
              fieldLabel: "immunizations",
              // placeholder: "Type to search",
              inputParentClass: "w-full pr-3 pb-4",
            },
          ],
        },
      ],
    },
    {
      parentType: "wrap-plain",
      customParentClass: "flex flex-wrap max-w-full",
      customChildClass: "w-full md:flex-1",
      wrap: [
        {
          type: "input-group",
          parentType: "wrap-with-flex",
          header: "Medications",
          customClass: "md:py-3",
          customChildClass: "w-full md:flex-1",
          formRender: [
            {
              type: "text",
              name: "medications",
              label: "Comments",
              fieldLabel: "medications",
              // placeholder: "Type to search",
              inputParentClass: "w-full pr-3 pb-4",
            },
          ],
        },
        {
          type: "input-group",
          parentType: "wrap-with-flex",
          header: "Additional Notes",
          customClass: "md:py-3",
          customChildClass: "w-full md:flex-1",
          formRender: [
            {
              type: "text",
              name: "additional_notes",
              label: "Comments",
              fieldLabel: "additional_notes",
              // placeholder: "Type to search",
              inputParentClass: "w-full md:pr-3 pb-4",
            },
          ],
        },
      ],
    },
  ];

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Backspace") {
        setIsBackspace(true);
      } else if (!/^[0-9]$/.test(event.key)) {
        setIsAlphabatic(true);
      } else {
        setIsBackspace(false);
        setIsAlphabatic(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const onSubmit = async (data) => {
    if (loading) return;
    setLoading(true);
    const clinicalInformation = {
      patient_visit_id: patientVisitId,
      ...data,
    };
    const endpoint = edit
      ? API_ENDPOINTS.EDIT_CLINICAL_INFORMATION_DETAILS
      : API_ENDPOINTS.ADD_CLINICAL_INFORMATION_DETAILS;
    await commonPostApi(endpoint, clinicalInformation, {
      headers,
    }).then((data) => {
      if (data?.data) {
        showToast(
          TOAST_TYPE.SUCCESS,
          edit ? FEATURE_MSG.EXAMINATION.CLINICAL_INFO_UPDATED : FEATURE_MSG.EXAMINATION.CLINICAL_INFO_ADDED
        );
        getClinicalInformation();
      } else {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
      }
      setLoading(false);
    });
  };
  const submitButtons = [
    {
      type: "primarySuccessButton",
      label: "Save Changes",
      class: "md:w-11rem md:pr-3 w-8rem",
      onClick: handleSubmit(onSubmit),
    },
    {
      type: "secondaryButton",
      label: "Discard",
      class: "w-6rem",
      onClick: () => {
        discard();
      },
    },
  ];
  const discard = () => {
    if (edit && clinicalData) {
      reset({
        ...defaultValues,
        ...clinicalData,
        allergies: toReturnValue(clinicalData?.allergies) || [],
        medical_history: toReturnValue(clinicalData?.medical_history) || [],
        ophthalmic_history: toReturnValue(clinicalData?.ophthalmic_history) || [],
        family_history: toReturnValue(clinicalData?.family_history) || [],
      });
    } else {
      reset(defaultValues);
      setAllergies([]);
      setMedicalHistory([]);
      setOphthalmicHistory([]);
      setfamilyHistory([]);
    }
  };


  const fetchOptions = async (lookupTypeName, setOptions) => {
    const data = { lookup_type_name: lookupTypeName };
    try {
      const response = await commonPostApi(API_ENDPOINTS.SEARCH_LOOKUP_DETAILS, data, {
        headers,
      });
      const optionsData = response?.data?.data || [];
      const formattedOptions = optionsData.map((item) => ({
        label: item.name,
        value: item.lookup_id,
      }));
      setOptions(formattedOptions);
    } catch (err) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
    }
  };
  useEffect(() => {
    if (bloodPressure) {
      if (
        bloodPressure.length === 3 &&
        !isBackspace &&
        !bloodPressure.includes("/")
      ) {
        setValue("blood_pressure", bloodPressure + "/");
      }
      if (bloodPressure.length > 3 && !bloodPressure.includes("/")) {
        const firstPart = bloodPressure.slice(0, 3);
        const secondPart = bloodPressure.slice(3);
        setValue("blood_pressure", firstPart + "/" + secondPart);
      }
    }
    lookupTypes.forEach(({ type, setter }) => {
      fetchOptions(type, setter);
    });
  }, [bloodPressure, setValue]);

  useEffect(() => {
    if (isBackspace) {
      setValue("weight", "");
    } else if (isAlphabatic) {
      const alphabet = weight.replace(/\D/g, "");
      setValue("weight", weight ? alphabet + "kg" : "");
    } else {
      const sanitizedWeight = weight?.replace("kg", "");
      setValue("weight", weight ? sanitizedWeight + "kg" : "");
    }
  }, [weight]);

  useEffect(() => {
    if (isBackspace) {
      setValue("height", "");
    } else if (isAlphabatic) {
      const alphabet = height.replace(/\D/g, "");
      setValue("height", height ? alphabet + "cm" : "");
    } else {
      const sanitizedheight = height?.replace("cm", "");
      setValue("height", height ? sanitizedheight + "cm" : "");
    }
  }, [height]);

  useEffect(() => {
    getClinicalInformation();
  }, [patientVisitId]);

  const toReturnValue = (data) => {
    return data?.map((item) => item?.value) || null;
  };
  const getClinicalInformation = async () => {
    const data = { patient_visit_id: patientVisitId };

    try {
      const response = await commonPostApi(
        API_ENDPOINTS.SEARCH_CLINICAL_INFORMATION_DETAILS,
        data,
        { headers }
      );

      const formData = response?.data?.data;

      if (formData && Object.keys(formData).length !== 0) {
        setEdit(true);
        setClinicalData(formData);
        reset({
          ...defaultValues,
          ...formData,
          allergies: toReturnValue(formData?.allergies) || [],
          medical_history: toReturnValue(formData?.medical_history) || [],
          ophthalmic_history: toReturnValue(formData?.ophthalmic_history) || [],
          family_history: toReturnValue(formData?.family_history) || [],
        });
      } else {
        setEdit(false);
        setClinicalData(null);
        reset(defaultValues);
        setAllergies([]);
        setMedicalHistory([]);
        setOphthalmicHistory([]);
        setfamilyHistory([]);
      }

    } catch (err) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
    }
  };
  return (
    <div>
      {totalForm?.map((item, index) => {
        return renderInputHeader(item, index, setValue, watch, control, errors);
      })}
      <div className="md:mt-6 md:ml-2">
        <AddButtonSection disabled={Object.keys(dirtyFields).length === 0 || loading} buttons={submitButtons} />
      </div>
      <DevTool control={control}></DevTool>
    </div>
  )
};